export default __webpack_public_path__ + "static/media/06.e78bdb37.jpg";